import BaseModule from '../BaseModule';

export default {
	mixins: [BaseModule],
	methods: {		
		buildHTMLMonthlyDay(isDisabled, isVacation, isCalendarVisible, calendar, workdayId, colors) {
			if (isDisabled) {
				return `<div style="padding: 1px; border-right: 1px solid #ddd; height: 48px; min-width: 36px; width: 100%; text-align: center; font-weight: 300; display: flex; align-items: center; justify-content: center; cursor: pointer; background-color: #f5f5f5;"></div>`;
			}
			
			let html = `<div style="border-right: 1px solid #ddd; height: 48px; min-width: 36px; width: 100%; text-align: center; font-weight: 300; display: flex; align-items: center; justify-content: center; cursor: pointer; ${this.getBackgroundColor(colors)}">`;
			
			if (!isVacation) {
				html += `<div style="margin: 0 auto; height: 25px; width: 25px; display: flex; align-items: center; justify-content: center; padding: 12px; font-size: 12px; font-weight: 500; color: #79909c; line-height: 10px; ${this.getMonthlyCalendarStyle(isCalendarVisible, calendar)}">`;
				
				if (isCalendarVisible) {
					html += `<span style="font-size: 0.8em; height: 100%; display: inline-flex; align-items: center; ${this.getMonthlyCalendarTextColor(isCalendarVisible, calendar, workdayId)}">${this.getMonthlyCalendarText(isCalendarVisible, calendar)}</span>`;
				}

				html += '</div>';
			}

			html += '</div>';

			return html;
		},
		buildHTMLWeeklyDay(isDisabled, isCalendarVisible, calendar, workdayId, projectsTextAndColor, dayRequests, companyNotes, colors) {
			if (isDisabled) {
				return `<div style="padding: 1px; height: 75px; border-right: 1px solid #ddd; text-align: center; font-weight: 300; display: flex; align-items: center; justify-content: center; cursor: pointer; background-color: #f5f5f5;"></div>`;
			}
			
			let html = `<div style="border-right: 1px solid #ddd; height: 100%; min-height: 75px; min-width: 140px; width: 100%; font-weight: 400; cursor: pointer; padding: 5px 0; ${this.getBackgroundColor(colors)}">`;
			
			if (isCalendarVisible) {
				html += `<span class="calendar-weekly-day" style="margin: 0 4px; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #000000; font-weight: 400; ${this.getWeeklyCalendarTextColor(isCalendarVisible, calendar, workdayId)}">${this.getWeeklyCalendarText(calendar)}</span>`;
			}	
			
			html += '<div class="calendar-weekly-day" style="margin: 0 4px; display: block;">';
			
			for (let i = 0; i < projectsTextAndColor.length; i++) {
				const project = projectsTextAndColor[i];

				html += '<div style="margin: 0; padding: 0; display: inline;">';
				
				html += `<span style="color: ${project.color}">${project.text}</span>`;
				if (this.hasNextProjectText(projectsTextAndColor, i)) {
					html += '<span>, </span>';
				}
				
				html += '</div>';
			}
						
			if (companyNotes) {
				html += `<p class="mx-1 calendar-weekly-day" style="color: #707070; line-height: 16px; white-space: break-spaces; margin-bottom: 1px;">${companyNotes}</p>`;
			}
		
			html += '</div>';

				if (dayRequests && dayRequests.length > 0) {
					html += '<div class="calendar-weekly-day" style="margin: 2px 4px 0 4px; display: block;">';

					for (let i = 0; i < dayRequests.length; i++) {
						const request = dayRequests[i];
						const title = request && request.recordTitle ? this.escapeHtml(request.recordTitle) : '-';

						html += `<span data-calendar-request-index="${i}" class="calendar-weekly-request-link" style="display: block; line-height: 15px;">${title}</span>`;
					}

					html += '</div>';
				}
	
			html += '</div>';

			return html;
		},
		buildHTMLHollyDay(isVacation, isCalendarVisible, calendar, colors) {
			let html = `<div style="border-right: 1px solid #ddd; height: 100%; text-align: center; font-weight: 300; display: flex; align-items: center; justify-content: center; cursor: pointer; ${this.getMonthlyBackgroundColor(colors)}">`;
			
			if (!isVacation) {
				html += `<div style="margin: 0 auto; height: 25px; width: 25px; display: flex; align-items: center; justify-content: center; padding: 12px; font-size: 12px; font-weight: 500; color: #79909c; line-height: 10px; ${this.getMonthlyCalendarStyle(isCalendarVisible, calendar)}">`;
				html += '</div>';
			}

			html += '</div>';

			return html;
		},
		buildHtmlSummary(value) {
			return `<span style="font-size: 0.75em; height: 100%; display: inline-flex; align-items: center;">${value}</span>`;			
		},
			escapeHtml(value) {
				if (value === null || value === undefined) {
					return '';
				}

			return String(value)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
					.replace(/"/g, '&quot;')
					.replace(/'/g, '&#39;');
			},
			//////////////////////////////////////////////////////////////////////////////////////////////////////
			// COMMON

		getBackgroundColor(colors) {
			if (colors.length === 0) {
				return '';
			}

			if (colors.length > 1) {
				let gradient = 'linear-gradient(135deg';

				for (let cp = 0; cp < colors.length; cp++) {
					let pct = cp * 100 / (Math.max(colors.length, 2));
					gradient += `, ${colors[cp]} ${pct}%`;

					pct = (cp + 1) * 100 / (Math.max(colors.length, 2));
					gradient += `, ${colors[cp]} ${pct}%`;
				}

				gradient += ')';

				return `background: ${gradient};`;
			}
				
			return `background: ${colors[0]};`;
		},

		//////////////////////////////////////////////////////////////////////////////////////////////////////
		// MONTHLY

		getMonthlyCalendarText(isCalendarVisible, calendar) {
			if (!isCalendarVisible || !calendar && !calendar.initials && !calendar.name) {
				return '';
			}

			if (calendar.initials) {
				return calendar.initials.toUpperCase();
			}

			let name = calendar.name.substring(0, 1).toUpperCase();
			const posSpace = calendar.name.indexOf(' ');
			if (posSpace !== -1) {
				name += calendar.name.substring(posSpace + 1, posSpace + 2).toUpperCase();
			}

			return name;
		},
		getMonthlyCalendarStyle(isCalendarVisible, calendar) {
			if (!isCalendarVisible || !calendar) {
				return '';
			}

			let style = 'border: none; border-radius: 100%; ';

			if (calendar.color) {
				style += ` background-color: ${this.convertColorToHex(calendar.color)};`;
			} else {
				style += ' background-color: #FFFFFF;';
			}

			return style;
		},
		getMonthlyCalendarTextColor(isCalendarVisible, calendar, workdayId) {
			if (!isCalendarVisible || !calendar) {
				return '';
			}

			if (!workdayId) {
				return 'color: #BDBDBD;';
			}

			return 'color: #185EA9;';
		},

		//////////////////////////////////////////////////////////////////////////////////////////////////////
		// WEEKLY

		getWeeklyCalendarText(calendar) {
			if (!calendar && !calendar.name) {
				return '';
			}

			return calendar.name;
		},
		hasNextProjectText(projectsTextAndColor, index) {
			if (!projectsTextAndColor || projectsTextAndColor.length === 0 || index >= projectsTextAndColor.length - 1) {
				return false;
			}
			return projectsTextAndColor[index + 1].text ? true : false;
		},
		getWeeklyCalendarTextColor(isCalendarVisible, calendar, workdayId) {
			if (!isCalendarVisible || !calendar) {
				return '';
			}

			if (!workdayId) {
				return 'color: #000000;';
			}

			return 'color: #185EA9;';
		},
		
		//////////////////////////////////////////////////////////////////////////////////////////////////////

	}
}
